import { render } from "./line-chart.vue?vue&type=template&id=35f01fbc"
import script from "./line-chart.vue?vue&type=script&lang=js"
export * from "./line-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__